import v1_0 from './v1-0/v1-0.json';
import shared from './shared.json';
import utils from './shared';

export const LIV_VAGINAL_MICROBIOME_v1_0 = v1_0;
export const LIV_VAGINAL_MICROBIOME_shared = shared;
export const LIV_VAGINAL_MICROBIOME_VERSIONS = [
	{
		label: '1.0',
		value: '1.0',
	},
];

export const LIV_VAGINAL_MICROBIOME: { [key: string]: any } = {
	'1.0': LIV_VAGINAL_MICROBIOME_v1_0,
	shared: LIV_VAGINAL_MICROBIOME_shared,
};

export const LIV_VAGINAL_MICROBIOME_UTILS = utils;

